import { ZoneId } from '@js-joda/core';
import {
  DecimalSeparator,
  MetricPressureUnit,
  ProjectModule,
  ThousandsSeparator
} from 'providers/api';
import { createContext } from 'react';

export interface IProjectContext {
  state: {
    timeZone: ZoneId;
    projectId: string;
    clientId: string;
    enabledModules: ProjectModule[],
    decimalSeparator: DecimalSeparator;
    thousandsSeparator: ThousandsSeparator;
    metricPressureUnit: MetricPressureUnit;
  }
}

const ProjectContext = createContext<IProjectContext | null>(null);

export default ProjectContext;
